import { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import type { MenuProps } from "antd";
import { Menu } from "antd";
import {
  CloudOutlined,
  HomeOutlined,
  UserOutlined,
  DashboardOutlined,
  KeyOutlined,
  WifiOutlined,
  ControlOutlined,
  AppstoreOutlined,
  CompassOutlined,
  RadarChartOutlined,
} from "@ant-design/icons";

import {
  Site,
} from "../model/model";

import type { OptionCallbackFunc, OptionsCallbackFunc } from "../components/Autocomplete";
import Autocomplete from "../components/Autocomplete";
import SessionStore from "../model/SessionStore";

function SideMenu() {
  const [siteId, setSiteId] = useState<string>("");
  const [site, setSite] = useState<Site>();
  const [selectedKey, setSelectedKey] = useState<string>("");

  const location = useLocation();
  const navigate = useNavigate();

  
  const setSiteData = () => {
    setSiteId(SessionStore.getSiteId());
    SessionStore.getClient().getSite(siteId, SessionStore.getBearer()).then((resp) => {
      setSite(resp.data);
    });
  };

  const getSiteOptions = (search: string, fn: OptionsCallbackFunc) => {
   
    SessionStore.getClient().getAllSites(SessionStore.getBearer()).then((resp) => {
      const options = resp.data.map((o, i) => {
        return { label: o.name, value: o.id};
      });
      fn(options);
    }
  )};

  const getSiteOption = (id: string, fn: OptionCallbackFunc) => {
    if (site) {
      fn({ label: site.name, value: site.id });
    }
};

  const onSiteSelect = (value: string) => {
    SessionStore.setSiteId(value);
    navigate(`/site/${value}`);
  };


  const parseLocation = useCallback(() => {
    const path = location.pathname;
    console.log("path:"+path);
    const tenantRe = /\/site\/([\w-]{36})/g;
    const match = tenantRe.exec(path);

    if (match !== null && siteId !== match[1]) {
      SessionStore.setSiteId(match[1]);
    }
    setSelectedKey(path.substring(1));

    if (/\/site\/(.*?)\/users?/g.exec(path)) {
      setSelectedKey("site-users");
    }

   if (/\/site\/(.*?)\/api-keys?/g.exec(path))  {
      setSelectedKey("api-keys");
    }
    if (/\/site\/(.*?)\/devices?/g.exec(path)) {
      setSelectedKey("site-devices");
    }

    if (/\/site\/(.*?)\/zones?/g.exec(path)) {
      setSelectedKey("site-zones");
    }

  }, [location.pathname, siteId]);

  useEffect(() => {
    SessionStore.on("site.change", setSiteData);
    setSiteData();
    parseLocation();
    return () => {
      SessionStore.removeListener("site.change", setSiteData);
    };
  }, [parseLocation]);

  useEffect(() => {
    parseLocation();
  }, [location, parseLocation]);

  const items: MenuProps["items"] = [];

  if (site) {
    items.push({
      key: "site-root",
      label: "Site: " + site.name,
      icon: <HomeOutlined />,
      children: [
        {
          key: "site",
          icon: <DashboardOutlined />,
          label: <Link to={`/site/${siteId}/dash`}>Site: {site.name}</Link>,
        },
        {
          key: "site-devices",
          icon: <WifiOutlined />,
          label: <Link to={`/site/${siteId}/devices`}>Devices</Link>,
        },
        {
          key: "site-zones",
          icon: <ControlOutlined />,
          label: <Link to={`/site/${siteId}/zones`}>Zone Configs</Link>,
        },
        {
          key: "site-users",
          icon: <UserOutlined />,
          label: <Link to={`/site/${siteId}/users`}>Users</Link>,
        },
        {
          key: "api-keys",
          icon: <KeyOutlined />,
          label: <Link to={`site/${siteId}/api-keys`}>API Keys</Link>,
        },
      ],
    });
  }

  items.push({
      key: "menu",
      label: "Menu",
      icon: <CompassOutlined />,
      children: [
        {
          key: "dash",
          icon: <DashboardOutlined />,
          label: <Link to={`/dash`}>Dashboard</Link>,
        },
        {
          key: "ios",
          icon: <RadarChartOutlined />,
          label: <Link to={`/ios`}>Integrations</Link>,
        },
        {
          key: "sites",
          icon: <AppstoreOutlined />,
          label: <Link to={`/sites`}>Sites</Link>,
        },
        {
          key: "users",
          icon: <UserOutlined />,
          label: <Link to={`/users`}>Users</Link>,
        },
        {
          key: "device-profiles",
          icon: <ControlOutlined />,
          label: <Link to={`/device-profiles`}>Device Profiles</Link>,
        },
        // {
        //   key: "gateways",
        //   icon: <CloudOutlined />,
        //   label: <Link to={`/gateways`}>Gateways</Link>,
        // },
      ],
    });
 
 

  return (
    <div>
      <Autocomplete
        placeholder="Select site"
        className="org-select"
        getOption={getSiteOption}
        getOptions={getSiteOptions}
        onSelect={onSiteSelect}
        value={siteId}
      />
      <Menu
        mode="inline"
        openKeys={["menu", "site-root"]}
        selectedKeys={[selectedKey]}
        expandIcon={<div></div>}
        items={items}
      />

    </div>
  );
}

export default SideMenu;
